const START_LOADING = 'app/loading/START_LOADING'
const FINISH_LOADING = 'app/loading/FINISH_LOADING'

export { FINISH_LOADING, START_LOADING }
